import { css, useTheme } from "@emotion/react";
import clsx from "clsx";
import { useContext } from "react";

import iconContext from "./iconContext.jsx";
import parseStyle from "./parseStyle.js";
import useThemeProps from "./useThemeProps.jsx";

export default function Icon(props) {
  props = useThemeProps({ name: "Icon", props });
  let {
    children,
    color,
    name,
    size = "1em",
    src,
    verticalAlign = "-15%",
    style = {},
    className,
    ...restProps
  } = props;
  void children;

  const theme = useTheme();
  const fontSize = theme.getLength(size);

  let { getIconSrc } = useContext(iconContext);
  if (name) {
    src = getIconSrc(name);
  }

  if (!src) {
    if (process.env.NODE_ENV !== "production") {
      if (name) {
        // eslint-disable-next-line no-console
        console.warn(
          `Could not find any icon by the name "${name}". Did you wrap your app in an <IconProvider> and pass a "getIconSrc" prop?`,
        );
      } else {
        // eslint-disable-next-line no-console
        console.warn(`No "src" or "name" prop provided to <Icon> component.`);
      }
    }
  }

  return (
    <span
      css={css`
        --icon-color: ${color && theme.getColor(color)};
        color: var(--icon-color, inherit);
        display: inline-block;
        vertical-align: ${verticalAlign};
        font-size: ${fontSize};
        background-color: currentColor;
        width: 1em;
        height: 1em;
        mask-repeat: no-repeat;
        mask-size: 100% 100%;
        mask-image: url(${src});
        ${parseStyle(style, theme)};
      `}
      className={clsx("wsui-icon", className)}
      {...restProps}
    />
  );
}
